import React, { useEffect, useMemo, useState } from 'react';

export const useTimer = ({ expireTime, onExpire = () => {}}) => {
    const [time, setTime] = useState('00:00');

    const timer = useMemo(() => new Worker(new URL('./worker.js', import.meta.url)), []);

    useEffect(() => {
        if (window.Worker) {
            timer.postMessage(expireTime);
            timer.onmessage = (e) => {
                if (e.data === '0') {
                    onExpire();
                    timer.terminate();
                } else {
                    setTime(e.data);
                }
            }
        }
    }, [timer])
    return time;
};
